// select options
import StdOpt from '@/components/StdOpt'
import RemoteOpt from '@/components/RemoteOpt'
import RegionOpt from '@/components/RegionOpt'

// basic/number/text fields
import BaseField from '@/components/BaseField'
import IDField from '@/components/IDField'
import RankField from '@/components/RankField'
import NumberField from '@/components/NumberField'
import TextField from '@/components/TextField'
import TinymceField from '@/components/TinymceField'
import TimeField from '@/components/TimeField'
import DurationField from '@/components/DurationField'
import PhoneField from '@/components/PhoneField'
import DatePicker from '@/components/DatePicker'

// special fields
import ProductSelector from '@/components/ProductSelector'
import SalesTime from '@/components/SalesTime'
import EventDate from '@/components/EventDate'
import FreeCover from '@/components/FreeCover'
import AuthInput from '@/components/AuthInput'
import PasswordInput from '@/components/PasswordInput'
import CoverImg from '@/components/CoverImg'
import AlbumImg from '@/components/AlbumImg'
import MFAQRCode from '@/components/MFAQRCode'
import GmapLoc from '@/components/GmapLoc'
import TransField from '@/components/TransField'
import FlagItem from '@/components/FlagItem'
import RedeemCode from '@/components/RedeemCode'
import PromoAmount from '@/components/PromoAmount'
import BranchBlock from '@/components/BranchBlock'
import MerchantBlock from '@/components/MerchantBlock'
import MemberBlock from '@/components/MemberBlock'
import BranchPartner from '@/components/BranchPartner'
import ProductPartner from '@/components/ProductPartner'
import PopRow from '@/components/PopRow'
import BaseSOAField from '@/components/BaseSOAField'
import DocumentItem from '@/components/DocumentItem'
import SOABtns from '@/components/SOABtns'

// compound fields
import TagField from '@/components/TagField'
import ProductField from '@/components/ProductField'
import AmountField from '@/components/AmountField'
import BrandOrdersField from '@/components/BrandOrdersField'
import BrandField from '@/components/BrandField'
import BlogCategory from '@/components/BlogCategory'
import OrdersField from '@/components/OrdersField'
import MemberField from '@/components/MemberField'
import UserField from '@/components/UserField'
import UserEmailField from '@/components/UserEmailField'
import OrdersAmount from '@/components/OrdersAmount'
import OrdersProduct from '@/components/OrdersProduct'
import OrdersInvoice from '@/components/OrdersInvoice'
import OrdersRemark from '@/components/OrdersRemark'
import OrdersReview from '@/components/OrdersReview'
import OrdersDetail from '@/components/OrdersDetail'
import OrdersMovieTicket from '@/components/OrdersMovieTicket'
import MemberDetail from '@/components/MemberDetail'
import TxnField from '@/components/TxnField'
import ReservationRemark from '@/components/ReservationRemark'
import CancelRule from '@/components/CancelRule'
import MemberLevelDetail from '@/components/MemberLevelDetail'
import MultiTimeField from '@/components/MultiTimeField'

// list page
import Pager from '@/components/Pager'
import ActCol from '@/components/ActCol'
import ActBtn from '@/components/ActBtn'
import ConfirmBtn from '@/components/ConfirmBtn'
import WebLink from '@/components/WebLink'
import SearchInput from '@/components/SearchInput'
import ItemLink from '@/components/ItemLink'
import ListFilter from '@/components/ListFilter'
import ListIndex from '@/components/ListIndex'
import ListTable from '@/components/ListTable'
import OrdersLink from '@/components/OrdersLink'
import EmailList from '@/components/Email/List'

// related data manager
import ContactManager from '@/components/ContactManager'
import BossNowUser from '@/components/BossNowUser'

// detail page
import FormTitle from '@/components/FormTitle'
import FormBtn from '@/components/FormBtn'
import FormCard from '@/components/FormCard'
import FormItem from '@/components/FormItem'
import FormTabs from '@/components/FormTabs'
import EmailDetail from '@/components/Email/Detail'

// dialog
import ExportDialog from '@/components/ExportDialog'
import ImportDialog from '@/components/ImportDialog'
import MultiUpdateDialog from '@/components/MultiUpdateDialog'
import MultiDownloadDialog from '@/components/MultiDownloadDialog'
import InvoiceDialog from '@/components/InvoiceDialog'
import CustomNoteDialog from '@/components/NoteDialog/Custom'
import NoteByEditBookingsDialog from '@/components/NoteDialog/ByEditBookings'
import ReceiptDialog from '@/components/ReceiptDialog'

import { Timeline } from 'vue2vis'

const components = [
  StdOpt,
  RemoteOpt,
  RegionOpt,
  BaseField,
  IDField,
  RankField,
  NumberField,
  TextField,
  TinymceField,
  TimeField,
  DurationField,
  PhoneField,
  DatePicker,
  ProductSelector,
  SalesTime,
  EventDate,
  FreeCover,
  AuthInput,
  PasswordInput,
  CoverImg,
  AlbumImg,
  MFAQRCode,
  GmapLoc,
  TransField,
  FlagItem,
  RedeemCode,
  PromoAmount,
  TagField,
  ProductField,
  AmountField,
  BrandOrdersField,
  BrandField,
  BlogCategory,
  OrdersField,
  MemberField,
  UserField,
  UserEmailField,
  OrdersAmount,
  OrdersProduct,
  OrdersInvoice,
  OrdersRemark,
  OrdersReview,
  OrdersDetail,
  OrdersLink,
  OrdersMovieTicket,
  MemberDetail,
  TxnField,
  ReservationRemark,
  CancelRule,
  Pager,
  ActCol,
  ActBtn,
  ConfirmBtn,
  WebLink,
  SearchInput,
  ItemLink,
  ListFilter,
  ListIndex,
  ListTable,
  ContactManager,
  BossNowUser,
  FormTitle,
  FormBtn,
  FormCard,
  FormItem,
  FormTabs,
  ExportDialog,
  ImportDialog,
  MultiUpdateDialog,
  MultiDownloadDialog,
  InvoiceDialog,
  CustomNoteDialog,
  NoteByEditBookingsDialog,
  ReceiptDialog,
  BranchBlock,
  MerchantBlock,
  MemberBlock,
  BranchPartner,
  ProductPartner,
  MemberLevelDetail,
  MultiTimeField,
  PopRow,
  BaseSOAField,
  DocumentItem,
  SOABtns,
  EmailList,
  EmailDetail
]

export default {
  install (Vue) {
    components.map(component => {
      Vue.component(component.name, component)
    })
    Vue.component('timeline', Timeline)
  }
}

export {
  StdOpt,
  RemoteOpt,
  RegionOpt,
  BaseField,
  IDField,
  RankField,
  NumberField,
  TextField,
  TinymceField,
  TimeField,
  DurationField,
  PhoneField,
  DatePicker,
  ProductSelector,
  SalesTime,
  EventDate,
  FreeCover,
  AuthInput,
  PasswordInput,
  CoverImg,
  AlbumImg,
  MFAQRCode,
  GmapLoc,
  TransField,
  FlagItem,
  RedeemCode,
  PromoAmount,
  TagField,
  ProductField,
  AmountField,
  BrandOrdersField,
  BrandField,
  BlogCategory,
  OrdersField,
  MemberField,
  UserField,
  UserEmailField,
  OrdersAmount,
  OrdersProduct,
  OrdersInvoice,
  OrdersRemark,
  OrdersReview,
  OrdersDetail,
  OrdersLink,
  OrdersMovieTicket,
  MemberDetail,
  TxnField,
  ReservationRemark,
  CancelRule,
  Pager,
  ActCol,
  ActBtn,
  ConfirmBtn,
  WebLink,
  SearchInput,
  ItemLink,
  ListFilter,
  ListIndex,
  ListTable,
  ContactManager,
  BossNowUser,
  FormTitle,
  FormBtn,
  FormCard,
  FormItem,
  FormTabs,
  ExportDialog,
  ImportDialog,
  MultiUpdateDialog,
  MultiDownloadDialog,
  InvoiceDialog,
  CustomNoteDialog,
  NoteByEditBookingsDialog,
  ReceiptDialog,
  BranchBlock,
  MemberBlock,
  ProductPartner,
  MemberLevelDetail,
  BaseSOAField,
  DocumentItem,
  SOABtns,
  EmailList,
  EmailDetail
}
